import React from "react";
import styles from "./HowItWorksSection.module.css";
import { Container } from "../../common/Container";
import { howItWorksData } from "../../../data/sharedSpendData";
import { useIntersectionObserver } from "../../../hooks/useIntersectionObserver";

const icons: Record<string, React.FC> = {
  link: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round">
      <path d="M13.19 8.688a4.5 4.5 0 0 1 1.242 7.244l-4.5 4.5a4.5 4.5 0 0 1-6.364-6.364l1.757-1.757m13.35-.622 1.757-1.757a4.5 4.5 0 0 0-6.364-6.364l-4.5 4.5a4.5 4.5 0 0 0 1.242 7.244" />
    </svg>
  ),
  plus: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 9v6m3-3H9m12 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
    </svg>
  ),
  check: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round">
      <path d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
    </svg>
  ),
};

export const HowItWorksSection: React.FC = () => {
  const [ref, isVisible] = useIntersectionObserver<HTMLElement>({
    threshold: 0.1,
    triggerOnce: true,
  });

  return (
    <section id="how-it-works" className={styles.section} ref={ref}>
      <Container>
        <div className={styles.header}>
          <div className={styles.eyebrow}>How It Works</div>
          <h2 className={styles.title}>Up and running in minutes</h2>
          <p className={styles.subtitle}>
            No complicated setup. Just connect, create, and start tracking.
          </p>
        </div>

        <div className={`${styles.steps} ${isVisible ? styles.stepsVisible : ""}`}>
          {howItWorksData.map((step, index) => {
            const Icon = icons[step.icon];
            return (
              <div key={step.step} className={styles.step} style={{ transitionDelay: `${index * 120}ms` }}>
                <div className={styles.stepIconWrapper}>
                  <div className={styles.stepNumber}>{step.step}</div>
                  <div className={styles.stepIcon}>
                    {Icon && <Icon />}
                  </div>
                </div>
                {index < howItWorksData.length - 1 && (
                  <div className={styles.connector} aria-hidden="true" />
                )}
                <div className={styles.stepContent}>
                  <h3 className={styles.stepTitle}>{step.title}</h3>
                  <p className={styles.stepDescription}>{step.description}</p>
                </div>
              </div>
            );
          })}
        </div>
      </Container>
    </section>
  );
};
